import { render } from "./SuccessIcon.vue?vue&type=template&id=bc050b9e"
const script = {}

import exportComponent from "E:\\online_project\\app_pcw365\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__